import {
  AIClassificationJobRecord,
  AIClassificationJobStatusResponse,
  AIClassificationResponse,
  AIClassificationsResponse,
  GetAIClassificationsParams,
  RerunAIClassificationRequest,
  StartOrContinueAIClassificationRequest
} from '../types/AIClassification.types';
import API from './ApiBase';

const getAIClassificationsPath = (aiSystemId: string) =>
  `/ai-systems/${aiSystemId}/classifications`;

export const startOrContinueAIClassification = async ({
  aiSystemId,
  body
}: StartOrContinueAIClassificationRequest) => {
  try {
    const response = await API.post<AIClassificationResponse>(
      getAIClassificationsPath(aiSystemId),
      body
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const startAIClassification = startOrContinueAIClassification;

export const getAIClassifications = async (
  aiSystemId: string,
  params?: GetAIClassificationsParams
) => {
  try {
    const response = await API.get<AIClassificationsResponse>(
      getAIClassificationsPath(aiSystemId),
      { params }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const rerunAIClassification = async ({
  aiSystemId,
  body
}: RerunAIClassificationRequest) => {
  try {
    const response = await API.post<AIClassificationResponse>(
      `${getAIClassificationsPath(aiSystemId)}/rerun`,
      body
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAIClassificationJob = async (
  aiSystemId: string,
  jobId: string
) => {
  try {
    const response = await API.get<AIClassificationJobStatusResponse>(
      `${getAIClassificationsPath(aiSystemId)}/${jobId}`
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAIClassificationJobStatus = getAIClassificationJob;

export const resumeAIClassification = async (
  aiSystemId: string,
  jobId: string
) => {
  try {
    const response = await API.post<AIClassificationJobRecord>(
      `${getAIClassificationsPath(aiSystemId)}/${jobId}/resume`
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const signAIClassificationReport = async (
  aiSystemId: string,
  jobId: string
) => {
  try {
    const response = await API.post<AIClassificationJobRecord>(
      `${getAIClassificationsPath(aiSystemId)}/${jobId}/sign`
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const donwloadAIPreliminaryReport = async (
  aiSystemId: string,
  jobId: string
): Promise<Blob> => {
  try {
    const response = await API.get<Blob>(
      `${getAIClassificationsPath(aiSystemId)}/${jobId}/report-pdf`,
      {
        responseType: 'blob'
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
